import { useEffect, useState } from 'react'
import SystemPromptsPage from './system-prompts'
import useAppState from '@/contexts/state'
import { useNavigate } from 'react-router-dom'
import DocumentsMetricsPage from './documents-metrics'
import { Button } from '@/components/ui/button'
import MarketingEmailsPage from './marketing-email/marketing-emails'
import ProductMetadataPage from './product-metadata'

const SUPER_ADMIN_EMAILS = [
  'zeydanwar@cobrief.co.uk',
  'zarlushzaidi@cobrief.co.uk',
  'alireza@dreamteam.codes',
  'mohammad+7@dreamteam.codes',
  'mohammad@dreamteam.codes',
]

const ADMINISTRATOR_PAGES = {
  systemPrompts: {
    label: 'System Prompts',
    component: <SystemPromptsPage />,
  },
  documentsMetrics: {
    label: 'Documents Metrics',
    component: <DocumentsMetricsPage />,
  },
  marketingEmails: {
    label: 'Marketing Emails',
    component: <MarketingEmailsPage />,
  },
  productMetadata: {
    label: 'Product Metadata',
    component: <ProductMetadataPage />,
  },
}

export default function AdministratorPage() {
  const [isAuthorized, setIsAuthorized] = useState(false)
  const navigate = useNavigate()
  const user = useAppState(state => state.user)
  const [activePage, setActivePage] = useState<keyof typeof ADMINISTRATOR_PAGES>('productMetadata')

  // Authorization check
  useEffect(() => {
    const userEmail = user?.email
    if (!userEmail || !SUPER_ADMIN_EMAILS.includes(userEmail)) navigate('/dashboard')
    else setIsAuthorized(true)
  }, [user, navigate])

  if (!isAuthorized) {
    return null
  }

  return (
    <main className="flex min-h-screen">
      {/* left sidebar */}
      <aside className="w-[12rem] border-r bg-muted/30 p-4">
        <nav className="sticky top-[5rem] space-y-2">
          <Button variant={'accentGreen'} className="w-full text-sm" size={'sm'} onClick={() => navigate('/dashboard')}>
            Back to Dashboard
          </Button>

          <hr className="pb-4 pt-2" />

          {Object.entries(ADMINISTRATOR_PAGES).map(([key, value]) => (
            <Button
              key={key}
              variant={activePage === key ? 'default' : 'outline'}
              className="w-full"
              onClick={() => setActivePage(key as keyof typeof ADMINISTRATOR_PAGES)}
            >
              {value.label}
            </Button>
          ))}
        </nav>
      </aside>

      {/* the actual page content */}
      <div className="flex-1 p-6">{ADMINISTRATOR_PAGES[activePage].component}</div>
    </main>
  )
}
